export const brandingColors = {
  red: "#ff6b73",
  "grey-font": "#435078",
  "grey-background": "#f3f6f9",
  "green-font": "#01402f",
};

export const getAgeGroupLabel = (code: string): string => {
  if (code === 'A') {
    return '15 - 20';
  } else if (code === 'B') {
    return '21 - 25';
  } else if (code === 'C') {
    return '26 - 35';
  } else if (code === 'D') {
    return '36 - 50';
  }
  else {
    return '50+';
  }
};

export const baseSiteUrl = "https://www.123skincare.pro";

export const getSeason = (latitude: number, date = new Date()): string => {
  const hemisphere = latitude >= 0 ? "north" : "south";
  const month = date.getMonth() + 1; // JavaScript months are 0-based
  const day = date.getDate();

  if (hemisphere === "north") {
    if ((month === 3 && day >= 21) || (month > 3 && month < 6) || (month === 6 && day <= 20)) {
      return "Spring";
    } else if ((month === 6 && day >= 21) || (month > 6 && month < 9) || (month === 9 && day <= 22)) {
      return "Summer";
    } else if ((month === 9 && day >= 23) || (month > 9 && month < 12) || (month === 12 && day <= 20)) {
      return "Autumn";
    } else {
      return "Winter";
    }
  } else {
    // Southern Hemisphere
    if ((month === 9 && day >= 23) || (month > 9 && month < 12) || (month === 12 && day <= 20)) {
      return "Spring";
    } else if ((month === 12 && day >= 21) || (month < 3) || (month === 3 && day <= 20)) {
      return "Summer";
    } else if ((month === 3 && day >= 21) || (month > 3 && month < 6) || (month === 6 && day <= 20)) {
      return "Autumn";
    } else {
      return "Winter";
    }
  }
}
